var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var AtIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 60,
    glyphHeight: 60
  }), React.createElement("path", {
    d: "M30 0C13.4471 0 0 13.4471 0 30C0 46.5529 13.4471 60 30 60C35.5412 60 40.7294 58.5882 45.2824 56.0824L45.3882 56.0118C46.2353 55.5529 46.8 54.6706 46.8 53.6824C46.8 52.2353 45.6 51.0353 44.1529 51.0353C43.6941 51.0353 43.2353 51.1765 42.8471 51.3882C39.0353 53.5059 34.6588 54.7059 30 54.7059C16.3765 54.7059 5.29412 43.6235 5.29412 30C5.29412 16.3765 16.3765 5.29412 30 5.29412C43.6235 5.29412 54.7059 16.3765 54.7059 30C54.7059 35.9294 52.8353 38.8235 49.4118 38.8235C46.3765 38.8235 44.1176 36.0706 44.1176 32.6471V18.5294C44.1176 17.0824 42.9176 15.8824 41.4706 15.8824C40.0235 15.8824 38.8235 17.0824 38.8235 18.5294V18.9882C36.4235 17.0471 33.3529 15.8824 30 15.8824C22.2 15.8824 15.8824 22.2 15.8824 30C15.8824 37.8 22.2 44.1176 30 44.1176C34.2706 44.1176 38.1176 42.2118 40.6941 39.2118C42.6 42.1765 45.7765 44.1176 49.4118 44.1176C55.9765 44.1176 60 38.7882 60 30C60 13.4471 46.5529 0 30 0ZM30 38.8235C25.1294 38.8235 21.1765 34.8706 21.1765 30C21.1765 25.1294 25.1294 21.1765 30 21.1765C34.8706 21.1765 38.8235 25.1294 38.8235 30C38.8235 34.8706 34.8706 38.8235 30 38.8235Z",
    fill: "black"
  }));
};
export var AtIconGlyph = function (props) {
  return React.createElement(AtIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};